<div class="container mt-5">
  <div class="card auth-card mx-auto">
    <div class="card-header"><i class="fa fa-lock mr-2"></i>Reset Password</div>
    <div class="card-body">
      <p>Choose a new password for your account.</p>

      @if (showError) {
        <div class="alert alert-danger py-2" role="alert">
          <span [innerHTML]="errorMessage"></span>
        </div>
      }
      @if (showSuccess) {
        <div class="alert alert-success py-2" role="alert">
          Your password has been reset. Please <a routerLink='/' > click here to log in. </a>
        </div>
      }

      <form [formGroup]="resetPasswordForm" autocomplete="off" novalidate (ngSubmit)="resetPassword(resetPasswordForm.value)">
        <div class="form-group">
          <label for="password">Password</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-lock"></i></span>
            </div>
            <input type="password" id="password" formControlName="password" class="form-control" placeholder="Password" />
          </div>
          @if (validateControl('password') && hasError('password', 'required')) {
            <small class="text-danger">Password is required</small>
          }
        </div>
        <div class="form-group">
          <label for="confirm">Confirm Password</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-lock"></i></span>
            </div>
            <input type="password" id="confirm" formControlName="confirm" class="form-control" placeholder="Confirm Password" />
          </div>
          @if (validateControl('confirm') && hasError('confirm', 'required')) {
            <small class="text-danger">Confirmation is required</small>
          }
          @if (hasError('confirm', 'mustMatch')) {
            <small class="text-danger">Passwords must match</small>
          }
        </div>

        <button type="submit" class="btn btn-primary btn-block mt-4" [disabled]="!resetPasswordForm.valid">Submit</button>
      </form>
    </div>
  </div>
</div>
